import { forwardRef } from 'react'
import type { MdHome } from 'react-icons/md'

type Props = {
  IconChildren: typeof MdHome
  color?: string
  iconColor?: string
}

export const Icon = forwardRef<HTMLSpanElement, Props>(
  ({ IconChildren, iconColor, ...props }, ref) => {
    return (
      <span {...props} ref={ref}>
        <IconChildren size={16} color={iconColor} />
      </span>
    )
  },
)

Icon.displayName = 'Icon'
